module.exports = __webpack_public_path__ + "img/9788994343327.63dc0124.jpg";